/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Error_Get_Sets_LogInputs */



/**
* | output |
* | --- |
* | "Error getting tag sets:" |
*
* @param {Tags_Manager_Error_Get_Sets_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_get_sets_log = /** @type {((inputs?: Tags_Manager_Error_Get_Sets_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Get_Sets_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de la recuperation des ensembles de tags :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Abrufen von Tag-Sets:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante il recupero dei set di tag:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при получении наборов тегов:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al obtener conjuntos de etiquetas:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("获取标签集时出错：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグ セットの取得中にエラーが発生しました:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग सेट प्राप्त करने में त्रुटि:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao obter conjuntos de tags:")
	return /** @type {LocalizedString} */ ("Error getting tag sets:")
});